module.exports = __webpack_public_path__ + "img/1text.3de46c13.png";